<template>
  <v-container fluid>

    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"

      absolute
    >
      <v-btn
        text
        @click="snackbar = false"
      >
        <v-icon small>mdi-close</v-icon>
      </v-btn>
      {{ message }}
    </v-snackbar>

    <div :class="paginatedFiles.length === 7 ? 'viewfarmer_box' : 'viewfarmer_box_empty'">
      <v-card

        max-width="100%"
      >

        <v-card-title class="accent--text" style="font-size: 14px; font-weight:700;"> FARMER STATEMENT</v-card-title>
        <!--                <v-divider class="mx-4"></v-divider>-->

        <div v-if="canBeGenerated()">
          <v-card-text>

            <v-form ref="form" v-model="valid" lazy-validation no-gutters justify="space-around">
              <v-row
                align="center" justify="start" no-gutters
              >
<!--                <v-col-->
<!--                  cols="2"-->
<!--                  class="d-flex justify-start"-->
<!--                >-->
                  <v-col :cols="12" :md="2" :sm="2" class="pa-2">
                  <!--                      <span class="accent&#45;&#45;text" style="font-size: 12px; font-weight:600;"> Deal Rate Code</span>-->
                  <v-text-field  type="text" label="Farmer National Id" v-model="farmerId"></v-text-field>

                </v-col>

                <v-col :cols="12" :md="1.5" :sm="2" class="pa-2">
                  <v-btn class="w-100 primary" @click="fetchFarmerStatementInfo()">Search</v-btn>
                </v-col>
<!--                <v-col :cols="12" :md="1.5" :sm="2" class="pa-2">-->
<!--                  <v-btn @click="this.getBuyerEslips" class="w-100 secondary">Search</v-btn>-->
<!--                </v-col>-->

<!--                <v-col :cols="12" :md="1.5" :sm="2" class="pa-2">-->
<!--                  <v-btn class="w-100 primary"  @click="exportExcel">Download</v-btn>-->
<!--                </v-col>-->
              </v-row>
              <v-row

              >
                <v-col cols="3" >
                  <span class="" v-if="farmerName">FARMER NAME : </span>
                  <span><b>{{farmerName}}</b></span>
                </v-col>
                <v-col cols="3" >
                  <span class="" v-if="memberNumber">MEMBER NUMBER : </span>
                  <span><b>{{memberNumber}}</b></span>
                </v-col>

              </v-row>
              <v-row>
                <v-col cols="3"  v-if="scheduleStats.length > 0">
                <b>TOTAL AMOUNT PAID</b>
                </v-col>
              </v-row>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-row v-if="scheduleStats.length > 0"

              >
                <v-spacer></v-spacer>
                <v-col cols="3"
                  v-for="(item, index) in scheduleStats"
                  :key="index"
                  class="d-flex"
                >
                  <b>{{ item.season}}</b> : KES. {{ item.amount }}
                </v-col>

              </v-row>

            </v-form>

          </v-card-text>

          <v-divider ></v-divider>
        </div>
        <v-card-title class="accent--text" style="font-size: 12px; font-weight:600;">
          Farmer statement
          <v-row>
            <v-col class="d-flex justify-end">
              <v-btn color="primary" v-if="statements.length>0" @click ="exportExcel" rounded >Download </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <table class="table">
            <thead class="thead">
            <tr>
              <th scope="col">FCS Name</th>
              <th scope="col">Season</th>
              <th scope="col">Weight</th>
              <th scope="col">Amount</th>
              <th scope="col">Payment Institution</th>
              <th scope="col">Account Number</th>
              <th scope="col">TransactionId</th>
              <th scope="col">Status</th>
              <th scope="col">Date Created</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="statement in statements" v-bind:key="statement.id">
              <td> {{ statement.orgName }}</td>
              <td> {{ statement.season }}</td>
              <td> {{ statement.totalCherryWeight }}</td>
              <td>{{ statement.netAmount }}</td>
              <td>{{ statement.instName }}</td>
              <td>{{ statement.accountNumber }}</td>
              <td>{{ statement.transactionId }}</td>
              <td>{{ statement.status }}</td>
              <td>{{ statement.dateCreated }}</td>

            </tr>
            </tbody>
          </table>
        </v-card-text>

        <v-card-actions>
          <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
          <v-spacer></v-spacer>
          <v-pagination
            v-model="page"
            :length="numberOfLinks"
            color="secondary"
                class="accent--text logoutbtn"
          ></v-pagination>
        </v-card-actions>
      </v-card>
    </div>

  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
import * as XLSX from 'xlsx'
import themes from 'devextreme/ui/themes'

export default {
	name: 'ccarfUsdKesRate',
	data: function () {
		return {
			valid: true,
			message: '',
			snackbar: false,
			snackbarColor: '',
			history: [],
			totalFarmers: 0,
			pagination: { sortBy: 'id', descending: true },
			search: '',
			paginatedFiles: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			page: 1,
			editDialog: false,
			confirmDialog: false,
			permissions: [],
			dealcode: 0,
      farmerId:'',
      memberNumber:'',
      farmerName:'',
      scheduleStats:[],
      statements:[],
      isValid: true,
			organizations: [],
			organization: {
				id: '',
				organisationName: ''
			},
			disableFarmer: {},
			confirmMessage: '',
			fcsCode: '',
			cherry: 0.00,
			debt: 0.00,
			limit: 0.00,
			action: '',
			isFcs: ' '
		}
	},
	mounted () {
    this.theUser = JSON.parse(localStorage.getItem('user'))
    console.log('user ===>> ', this.theUser)
    this.organisationType = this.theUser.organisation.organisationType.name
    this.organisationId = this.theUser.organisation.id
		this.permissions = store.state.user.roleId.permissions
		this.isFcs = store.state.user.organisation.organisationType.name === 'FARMER_SOCIETY'
		this.fcsCode = store.state.user?.organisation?.organisationCode
	},
	watch: {

    statements  () {
			this.paginatedFiles = this.paginationMethod(this.statements , 1, this.numberOfItemsPerPage)
			this.numberOfLinks = Math.ceil(this.statements .length / this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedFiles = this.paginationMethod(this.statements , val, this.numberOfItemsPerPage)
		}
	},
	computed: {
		filteredList: function () {
			if (this.search === '') {
				return this.paginatedFiles
			} else {
				return this.statements.filter(statement => {
					return (statement.orgName !== null ? statement.orgName.toLowerCase().includes(this.search.toLowerCase()) : ''.toLowerCase().includes(this.search.toLowerCase()))
            || (statement.name === null ? ''.toLowerCase().includes(this.search.toLowerCase()) : statement.name.toLowerCase().includes(this.search.toLowerCase()))
            || statement.status.statusName.toLowerCase().includes(this.search.toLowerCase())
				})
			}
		}
	},
	methods: {
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		ifFCS () {
			return this.isFcs
		},
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},

    checkFormValidity() {
      this.isValid = true;
      if(!this.farmerId){
        this.message = "Please Input Farmer Id"
        this.snackbar = true
        this.snackbarColor = 'error'
        this.isValid = false
      }
      return this.isValid
    },

    fetchFarmerStatementInfo(){
      if(this.checkFormValidity()) {
        this.fetchScheduleStats()
        this.fetchFarmerStatements()
      }
          },
		 fetchScheduleStats() {
			const url = config.serverURI + '/payment/fetchFarmerScheduleStats/' + this.organisationId + '/' + this.farmerId
       axios.get(url)
         .then(response => {
           if (response.data.error !== false) {
             this.message = response.data.message
             this.snackbar = true
             this.snackbarColor = 'error'
             console.log('Error is ' + this.message)
             return
           }
           this.scheduleStats = response.data.data
           console.log('Schedule Stats ', this.scheduleStats)
           this.message = response.data.message
           // this.snackbar = true
           // this.snackbarColor = 'primary'
         })
         .catch(error => {
           console.log('error', error.response)
           this.message = 'Error occurred while processing your request'
           // this.snackbar = true
           // this.snackbarColor = 'error'
         })
		},
    fetchFarmerStatements() {
      const url = config.serverURI + '/payment/fetchFarmerStatement/' + this.organisationId + '/' + this.farmerId
      axios.get(url)
        .then(response => {
          if (response.data.error !== false) {
            this.message = response.data.message
            this.snackbar = true
            this.snackbarColor = 'error'
            console.log('Error is ' + this.message)
            return
          }
          this.statements = response.data.data
          console.log('Statements', this.statements)
          this.farmerName = this.statements[0]?.name
          this.memberNumber = this.statements[0]?.memberNumber
          this.message = response.data.message
          this.snackbar = true
          this.snackbarColor = 'primary'
        })
        .catch(error => {
          console.log('error', error.response)
          this.message = 'Error occurred while processing your request'
          this.snackbar = true
          this.snackbarColor = 'error'
        })
    },
    exportExcel () {
      // Define worksheet and workbook
      const ws = XLSX.utils.json_to_sheet(this.statements
        //   {
        //     header: Object.keys(this.headers)
        //   }
      )
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

      // Export workbook to file
      XLSX.writeFile(wb, this.farmerName + '_Farmer_Statement_' + Date.now() + '.xlsx')
    },
		canBeApproved (item) {
			return item.status.id === 3 && this.hasPerm('CAN_APPROVE_CONVERSION_RATE')
		},
		canBeGenerated () {
			return this.hasPerm('CAN_VIEW_FARMER_STATEMENT')
		},
		showConfirmDialog (item, action) {
			this.confirmDialog = true
			this.item = item
			this.action = action
			if (action === 'APPROVE') {
				this.confirmMessage = 'Do you want to Approve the conversion rate(' + item?.rate + ') set for Deal code ' + item?.rateCode + ' ?'
			} else if (action === 'REJECT') {
				this.confirmMessage = 'Do you want to Reject conversion rate(' + item?.rate + ')  for Deal Code ' + item?.rateCode + ' ?'
			} else {
				console.error(action + 'Action not supported')
			}
		}

	}
}

</script>
<style>
.viewfarmer_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.viewfarmer_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.catalogue_box:after, .catalogue_box:before {
  right: 100%;
  top: 17%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.catalogue_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}

.catalogue_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}

.thead {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}

.table tbody tr > td.actions {
  font-size: 20px !important;
  color: #733D29 !important;
  padding-top: 0px;
}

.pagination {
  background-color: red;
}

.paginationtext {
  color: #733D29;
}

.pagination > li > a,
.pagination > li > span {
  border: 1px solid #F2D0A7;
  color: #733D29;
}

.pagination > li.active > .page-link {
  background: #00513B;
  color: #fff;
}

</style>
